import {useMutation} from '@apollo/client'
import React, {useEffect} from 'react'
import {Alert, Button, Modal, Spinner} from 'react-bootstrap'
import {DELETE_COMMISSION_REPORT} from '../../../gql/mutations/commissionReportMutations'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import { IResDeleteCommissionReport } from '../../../types/commissionReportApi'

interface IModalDeleteCommissionReport {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  infoEdit: {id: string; name: string}
}

export const ModalDeleteCommissionReport: React.FC<IModalDeleteCommissionReport> = ({
  infoEdit,
  isOpen,
  onClose,
  refetch,
}) => {
  const [gqlDeleteCommissionReport, {data, loading, error}] = useMutation<IResDeleteCommissionReport>(DELETE_COMMISSION_REPORT)

  useEffect(() => {
    if (error) toast.error('Error: ' + error.message)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.commissionReportDeleteMutation?.success) {
      toast.success(`Success: Commission report archived successfully`)
      onClose()
      refetch()
    } else if (data.commissionReportDeleteMutation?.errors?.length > 0) {
      toast.error(`Error: ${data.commissionReportDeleteMutation?.errors?.[0]?.message || 'something happened'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlDeleteCommissionReport({
      variables: {
        id: parseId(infoEdit.id),
      },
    })
  }
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Archive Commission Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className='text-primary'>
          Are you sure you want to archive this commission report "
          <span className='text-danger'>{infoEdit.name}</span>"?
        </h4>
        <Alert variant='warning' className='mt-3 mb-0'>
          This action hides the report from the default list and prevents future edits. It does not
          permanently delete the record.
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant='warning'
          className='d-flex align-items-center'
          disabled={loading}
          onClick={handleDelete}
        >
          {loading && <Spinner animation='border' size='sm' />}
          Archive
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
